<div
  class="container"
  fxLayout="column"
  fxLayoutAlign="center center"
  id="div_container_f3f597b4"
>
  <div class="inner-container text-center" id="div_inner-container_b0ca4171">
    <h2
      aria-label="We apologize"
      title="We apologize"
      class="text-uppercase font-weight-bold"
      id="h2_text-uppercase_90ac332d"
    >
      We apologize
    </h2>

    <p
      aria-label="We seem to be having an issue collecting"
      title="We seem to be having an issue collecting"
      class="text-summary"
      id="p_text-summary_316f24fb"
    >
      We seem to be having an issue collecting your submission.<br />
      <a
        aria-label="Contact us"
        title="Contact us"
        href="https://www.trinityrail.com/contact/"
        class="link"
        id="a_link_cb5636eb"
        >Contact us
      </a>
      and we’ll follow up soon.
    </p>
  </div>

  <div class="card-container" id="div_card-container_1766ff3d">
    <p id="p_9f338269">Want to try again?</p>
  </div>

  <div class="btn-panel" id="div_btn-panel_6554b3b7">
    <button
      id="btn-try-again"
      class="btn btn-primary-outline"
      (click)="BeginNew()"
    >
      BEGIN NEW SEARCH
    </button>
  </div>
</div>
